import type { ProgramsListParams } from '@/admin/api/programs';
import { programsApi } from '@/admin/api/programs';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export type { ProgramsListParams };

export const programsQuery = (params?: ProgramsListParams) =>
	queryOptions({
		queryKey: ['programs', params ?? {}] as const,
		queryFn: () => programsApi.list(params),
		placeholderData: keepPreviousData,
		staleTime: 60_000,
		gcTime: 5 * 60_000,
	});
